export default "__VITE_ASSET__C41WlP6w__"